module.exports = __webpack_public_path__ + "static/media/l_itdot_12.7102c018.png";